module.exports = __webpack_public_path__ + "img/banner_tr.f0e51e5f.jpg";